import React from "react"
import styles from "./FeedbackFormContent.module.scss"
import Rating from "../../../DialogMessage/components/Rating/Rating"
import DebouncedValidatableInput from "../../../../ValidatableInput/DebouncedValidatableInput"
import { OperatorFeedbackKeys, OperatorFeedbackValues } from "../../../../../models/Dialogs/operatorFeedbackForm"
import { ReactComponent as RobotIcon } from "../../../../../assets/images/feedback-form/robot.svg"
import { DIALOG_OPERATION_FEEDBACK_FORM_CONST } from "../../DialogOperatorFeedbackForm.const"
import { useFormikContext } from "formik"
import { useTranslation } from "react-i18next"

const { tNamespace, tPaths, testIds } = DIALOG_OPERATION_FEEDBACK_FORM_CONST

const FeedbackFormContent = () => {
    const { t } = useTranslation(tNamespace)
    const { setFieldValue, errors } = useFormikContext<OperatorFeedbackValues>()

    const handleSelectRating = (score: number) => {
        setFieldValue(OperatorFeedbackKeys.Score, score, true)
    }

    return (
        <>
            <div className={styles.content__suggestion}>{t(tPaths.defaultSuggestion)}</div>
            <RobotIcon className={styles.content__robot} data-testid={testIds.robotDefault} />
            <div>
                <div className={styles.content__rate}>{t(tPaths.rate)}</div>
                <Rating size="2x" selectCallback={handleSelectRating} data-testid={testIds.rating} />
                {errors["Score"] && <span className={styles.content__ratingError}>{errors["Score"]}</span>}
            </div>
            <div>
                <div className={styles.content__feedback}>{t(tPaths.feedback)}</div>
                <DebouncedValidatableInput
                    id="formOperatorFeedback"
                    as="textarea"
                    name={OperatorFeedbackKeys.Message}
                    className={styles.content__feedbackTextarea}
                    placeholder={t(tPaths.feedbackPlaceholder)}
                    testId={testIds.feedback}
                />
            </div>
        </>
    )
}

export default FeedbackFormContent
